import React, { memo, useContext } from "react";
import style from "styles/popUpCyberMobile.module.css";
import content from "styles/youtube.module.css";
import ThemeContext from '../../../../../context/themeContext'


const PopUpYoutube = () => {
    const { activeYoutube, toggleActiveYoutube } = useContext(ThemeContext);

    return (
        <div style={{ textAlign: 'center' }} className={activeYoutube ? style.popUpCyber : style.active} onClick={toggleActiveYoutube}>
            <div className={style.container}>
                <iframe
                  loading="lazy"
                    className={content.iframe}
                    src="https://www.youtube.com/embed/RiBkSzrvtEU"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </div>
        </div>
    )
}

export default memo(PopUpYoutube);
